export default "__VITE_ASSET__DXTZS80G__"